import { render } from "./VideoListSlider.vue?vue&type=template&id=6eb956b2"
import script from "./VideoListSlider.vue?vue&type=script&lang=js"
export * from "./VideoListSlider.vue?vue&type=script&lang=js"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__